export default {
  path: '/accessories',
  name: 'accessories',
  component: () => import('../components/accessory/Layout'),
  redirect: { name: 'AccessoryList' },
  meta: {
    breadcrumb: 'profile.accessory.accessories',
  },
  children: [
    {
      name: 'AccessoryList',
      path: '',
      component: () => import('../views/accessory/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'AccessoryCreate',
      path: 'new',
      component: () => import('../views/accessory/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'AccessoryUpdate',
      path: ':id/edit',
      component: () => import('../views/accessory/Update'),
      meta: {
        breadcrumb: 'profile.accessory.accessory',
      },
    },
    {
      name: 'AccessoryShow',
      path: ':id',
      component: () => import('../views/accessory/Show'),
      meta: {
        breadcrumb: 'profile.accessory.accessory',
      },
    },
    {
      name: 'Accessory',
      path: ':parent',
      component: () => import('../components/producttypefile/Layout'),
      meta: {
        breadcrumb: 'qualitycheck.product.producttypefiles',
      },
      children: [
        {
          name: 'ProducttypefileAccessoryCreate',
          path: 'new',
          component: () => import('../views/producttypefile/Create'),
          meta: {
            breadcrumb: 'global.add',
          },
        },
      ]

    },
  ]
};
